import moment from "moment";

export class ExternalMAMGatewayProviderInfo {
  constructor(
    public id: string,
    public externalMAMType: number,
    public createdDate: moment.Moment,
    public name: string,
    public isActive: boolean,
  ) {}

  public formatCreatedDate(): string {
    return moment(this.createdDate).format("YYYY-MM-DD");
  }
}
